import React, { useEffect, useState } from "react";
import { useI18n, ROLE_LABELS } from "../../i18n";
import { api, apiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../../components/ui/dialog";
import { toast } from "sonner";

const ROLES = ["vat_specialist", "supervisor", "quality_reviewer", "management", "platform_admin"];

export default function UsersAdmin() {
  const { t, pick } = useI18n();
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", role: "vat_specialist" });
  const load = () => api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {});
  useEffect(load, []);

  const create = async () => {
    try {
      await api.post("/admin/users", f);
      toast.success(t("saved"));
      setOpen(false); setF({ name: "", email: "", password: "", role: "vat_specialist" });
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-5 gc-fade-up">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("nav_users")}</h1>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="add-user-btn" className="rounded-full bg-[hsl(217_63%_15%)]">{t("add_user")}</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{t("add_user")}</DialogTitle></DialogHeader>
            <div className="space-y-4 pt-2">
              <div><Label>{t("name")}</Label><Input data-testid="user-name" className="mt-1.5" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></div>
              <div><Label>{t("email")}</Label><Input data-testid="user-email" type="email" className="mt-1.5" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></div>
              <div><Label>{t("password")}</Label><Input data-testid="user-password" type="password" className="mt-1.5" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} /></div>
              <div>
                <Label>{t("role")}</Label>
                <Select value={f.role} onValueChange={(v) => setF({ ...f, role: v })}>
                  <SelectTrigger data-testid="user-role" className="mt-1.5"><SelectValue /></SelectTrigger>
                  <SelectContent>{ROLES.map((r) => <SelectItem key={r} value={r}>{pick(ROLE_LABELS[r])}</SelectItem>)}</SelectContent>
                </Select>
              </div>
              <Button data-testid="user-create" onClick={create} className="w-full rounded-full bg-[hsl(158_64%_28%)]">{t("create")}</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
      <div className="rounded-2xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-muted-foreground text-xs"><tr>
            <th className="text-start px-4 py-3 font-medium">{t("name")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("email")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("role")}</th>
          </tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-border">
                <td className="px-4 py-3 font-medium">{u.name}</td>
                <td className="px-4 py-3 text-muted-foreground font-mono text-xs">{u.email}</td>
                <td className="px-4 py-3">{pick(ROLE_LABELS[u.role]) || u.role}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
